import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import "./payment.css";
import styles from "./styles.module.css";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
// import axios from "axios";
// import { payment, savePayment } from "../helper/PaymentApiCalls/payments";
// import TextField from "@mui/material/TextField";
// import { isAuthenticated } from "../helper/authApiCalls/auth";
// import jwtDecode from "jwt-decode";
import { AiTwotoneMail } from "react-icons/ai";
// import { Divider } from "@mui/material";
// function loadScript(src) {
//   return new Promise((resolve) => {
//     const script = document.createElement("script");
//     script.src = src;
//     script.onload = () => {
//       resolve(true);
//     };
//     script.onerror = () => {
//       resolve(false);
//     };
//     document.body.appendChild(script);
//   });
// }
// const _DEV_ = document.domain === "localhost";

const Payment = ({ don, setDon }) => {
  // console.log(don, "hey hello");
  // const [razorpay_payment_id, setRazorpay_payment_id] = useState("");
  // const [donate, setDonate] = useState();
  // const [success, setSucess] = useState(false);
  const success = false;
  // const [name, setName] = useState(
  //   isAuthenticated()
  //     ? jwtDecode(localStorage.getItem("_access_token")).name
  //     : ""
  // );
  // const [emailAdd, setEmailAdd] = useState(
  //   isAuthenticated()
  //     ? jwtDecode(localStorage.getItem("_access_token")).email
  //     : ""
  // );
  // const user = isAuthenticated();
  // console.log(user, "helolo");
  // const sendData = {
  //   totalAmount: donate,
  // };

  // async function Displayrazorpay() {
  //   const res = await loadScript(
  //     "https://checkout.razorpay.com/v1/checkout.js"
  //   );

  //   if (!res) {
  //     alert("Razorpay SDK failed to load. Are you online?");
  //     return;
  //   }
  //   const data = await payment(sendData);

  //   const options = {
  //     key: _DEV_ ? "rzp_test_8XhYIC8w5kEPuB" : "rzp_live_oYIb4rKWqK321t",
  //     currency: data.currency,
  //     amount: data.amount.toString(),
  //     order_id: data.id,
  //     name: "Donation",
  //     description: "Thank you ",

  //     handler: async function (response) {
  //       const sendData = {
  //         orderCreationId: data.order_id,
  //         razorpay_payment_id: response.razorpay_payment_id,
  //         razorpay_order_id: response.razorpay_order_id,

  //         razorpay_signature: response.razorpay_signature,
  //       };

  //       setRazorpay_payment_id(sendData.razorpay_payment_id);

  //       const result = await axios.post(
  //         "https://eduudr.herokuapp.com/api/v1/payment/success",
  //         sendData
  //       );

  //       if (result.data.msg === "success") {
  //         let Something = sendData.razorpay_payment_id;
  //         saveTheTransaction(Something);
  //         setSucess(true);
  //       }
  //     },
  //   };
  //   const paymentObject = new window.Razorpay(options);
  //   paymentObject.open();
  // }

  // function saveTheTransaction(Something) {
  //   const setData2 = {
  //     name: name,
  //     emailAdd: emailAdd,
  //     amountDonated: donate,
  //     razorpay_payment_id: Something,
  //   };

  //   savePayment(setData2).then((response) => {
  //     if (response.error) {
  //       console.log(response.error);
  //     } else {
  //       console.log("hurray bois");
  //     }
  //   });
  // }

  const handleClose = () => setDon(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    borderRadius: "10px",
    transform: "translate(-50%, -50%)",
    width: 500,
    height: 350,
    bgcolor: "var(--bg-secondary)",
    color: "var(--text-primary)",
    boxShadow: 34,
    p: 4,
    border: "1px solid var(--text-primary)",
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={don}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={don}>
          <Box sx={style}>
            {!success ? (
              <div className={styles.pay}>
                <div className="pay">
                  {/* <p className="donateText">Donate us for more free content</p> */}
                  <p className="donateText">
                    Connect here for financial support and sponsorship.
                  </p>
                  {/* <div>
                    <TextField
                      label="Amount to Donate"
                      type="number"
                      id="outlined-size-small"
                      size="small"
                      value={donate}
                      onChange={(e) => {
                        setDonate(e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <TextField
                      label="Your Name"
                      type="string"
                      id="outlined-size-small"
                      size="small"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <TextField
                      label="Your Email"
                      type="email"
                      id="outlined-size-small"
                      size="small"
                      value={emailAdd}
                      onChange={(e) => {
                        setEmailAdd(e.target.value);
                      }}
                    />
                  </div>
                  <div className={styles.paybut}>
                    <button
                      onClick={Displayrazorpay}
                      target="_blank"
                      className="checkout_button"
                    >
                      Donate Now
                    </button>
                  </div> */}

                  <div className={styles.contactline}>
                    <span> Email:</span>{" "}
                    <a href="mailto:contact@eduudr.org?subject=I'm interested in EduUdr India for sponsorship or financial support">
                      Contact@eduudr.org
                    </a>
                    <AiTwotoneMail className={styles.emailred} />
                  </div>
                </div>
              </div>
            ) : (
              <div className={styles.payshit}>
                <span>Thanks for your donation</span>
              </div>
            )}
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
export default Payment;
